export default __webpack_public_path__ + "static/culture-mobile-f79c3e14af4b04507d9bf56f68fed30c.webp";